<template>
  <div name="logical-statement-edit" class="addlist-wrapper clearfix">
    <template v-if="typeof editList.conj !== 'undefined'">
      <div class="list-box -edit clearfix">
        <div class="pull-left" style="font-weight: bold;">Conjunction</div>
        <i class="fa fa-check ungroup-button" @click="triggerEditList(index, editList)" />
        <select v-model="editList.conj"
                v-validate="'required'" data-vv-name="listConjunction"
                class="select-input-1"
                :class="{ 'input-error' : errors.has('listConjunction') }">
          <option v-for="(val, key) in listConjunctions" :value="key">{{ val }}</option>
        </select>
        <span v-show="errors.has('listConjunction')" class="validate-text">{{ errors.first('listConjunction') }}</span>
      </div>
    </template>
    <template v-if="typeof editList.conj === 'undefined'">
      <div class="list-box -edit clearfix">
        <div class="pull-left" style="font-weight: bold;">Statement</div>
        <i class="fa fa-check ungroup-button" @click="triggerEditList(index, editList)" />
        <select v-model="editList.field"
                v-validate="'required'" data-vv-name="listField"
                class="select-input-1"
                :class="{ 'input-error' : errors.has('listField') }">
          <option v-for="listField in listFields" :value="listField.code">{{ listField.description }}</option>
        </select>
        <span v-show="errors.has('listField')" class="validate-text">{{ errors.first('listField') }}</span>
        <select v-model="editList.operator"
                v-validate="'required'" data-vv-name="listOperator"
                class="select-input-2"
                :class="{ 'input-error' : errors.has('listOperator') }">
          <option v-for="listOperator in listOperators" v-if="listOperator.type.indexOf(findValueType(editList.field)) > -1" :value="listOperator.code">{{ listOperator.description }}</option>
        </select>
        <span v-show="errors.has('listOperator')" class="validate-text">{{ errors.first('listOperator') }}</span>
        <higher-order-value-component 
                      :labelCodsex="labelCodsex"
                      :nowLang="nowLang"
                      :listField="editList.field"
                       v-model="editList.value"
                      :findValueType="findValueType"
                      :findInputType="findInputType"
                      :findLovType="findLovType"
                      v-validate="'required'"
                      data-vv-value-path="listValue"
                      data-vv-as="listValue"
                      data-vv-name="listValue"
                      name="listValue"
        />
        <span v-show="errors.has('listValue')" class="validate-text">{{ errors.first('listValue') }}</span>
      </div>
    </template>
  </div>
</template>

<script>
  import higherOrderValueComponent from './higherOrderValueComponent'

  export default {
    name: 'logical-statement-edit',
    data () {
      return {
        editList: this.list
      }
    },
    watch: {
      'editList.conj' () {
        this.setDescConjAndDescStmt(this.editList)
      },
      'editList.field' () {
        this.setDescConjAndDescStmt(this.editList)
      },
      'editList.operator' () {
        this.setDescConjAndDescStmt(this.editList)
      },
      'editList.value' () {
        this.setDescConjAndDescStmt(this.editList)
      },
      list (newVal) {
        this.editList = newVal
      }
    },
    methods: {
      triggerEditList (index, editList) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.viewList(index, editList)
          }
        })
      }
    },
    props: {
      labelCodsex: {
        type: Object
      },
      nowLang: {
        type: String,
        default: 'th'
      },
      list: {
        type: Object,
        required: true
      },
      index: {
        type: Number
      },
      viewList: {
        type: Function
      },
      setDescConjAndDescStmt: {
        type: Function
      },
      findValueType: {
        type: Function
      },
      findInputType: {
        type: Function
      },
      findLovType: {
        type: Function
      },
      listFields: {
        type: Array,
        required: true
      },
      listConjunctions: {
        type: Object,
        required: true
      },
      listOperators: {
        type: Array,
        required: true
      }
    },
    components: {
      higherOrderValueComponent
    }
  }
</script>


// WEBPACK FOOTER //
// listEdit.vue?d70a22f4